module.exports = __webpack_public_path__ + "mo/img/piece-18.67564464.svg";